import { setupAuthForm, growlError } from './authForm';

setupAuthForm('form#sign_in_user', {
  onError: (xhr) => {
    switch (xhr.status) {
      case 500:
        growlError('Error', 3000);
        break;
      case 302:
        document.body.insertAdjacentHTML('beforeend', xhr.responseText);
        break;
      default:
        growlError(xhr.responseText, 3000);
    }
  }
});
